import { useEffect } from "react";

export function textContent(elem: React.ReactElement | string): string {
    if (!elem) {
        return '';
    }
    if (typeof elem === 'string') {
        return elem;
    }
    const children = elem.props && elem.props.children;
    if (children instanceof Array) {
        return children.map(textContent).join('');
    }
    return textContent(children);
}

export function valueUseEffect(fn: () => void, arrDep: any[]) {
    useEffect(fn, arrDep.map(dep => JSON.stringify(dep)));
}

export function arePropsEqualByJSON(prevProps: any, nextProps: any) {
    const res = JSON.stringify(prevProps) === JSON.stringify(nextProps);
    return res;
}